// ✅ Import fetch patch at the very top
import "./utils/fetchPatch";

// ✅ Import global scrollbar styles
import "./styles/scrollbar.css";

import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import { QueryClientProvider } from "@tanstack/react-query";
import React, { useMemo } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import App from "./App";
import { queryClient } from "./config/queryClient"; // ✅ Use configured client
import theme from "./theme"; // your custom theme

function ThemeWrapper({ children }) {
  const location = useLocation();
  // Simple auth check (replace with your real logic)
  const token = localStorage.getItem("token");
  const isSignedIn = Boolean(token);

  // Check if we're on public pages that should use default Chakra theme
  const publicPages = ['/', '/login', '/signup', '/ForgotPassword', '/pricing', '/why-choose-us', '/checkout/success', '/checkout/cancel'];
  const isPublicPage = publicPages.includes(location.pathname);

  // Memoize to prevent re-render flicker
  const activeTheme = useMemo(
    () => {
      // Always use default Chakra theme for public pages
      if (isPublicPage) {
        return undefined;
      }
      // Use custom theme only for signed-in users on protected pages
      return isSignedIn ? theme : undefined;
    },
    [isSignedIn, isPublicPage],
  );

  return <ChakraProvider theme={activeTheme}>{children}</ChakraProvider>;
}

ReactDOM.createRoot(document.getElementById("root")).render(
  // <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ThemeWrapper>
            <App />
          </ThemeWrapper>
        </BrowserRouter>
      </QueryClientProvider>
    </HelmetProvider>
  // </React.StrictMode>,
);
